import { useState, useCallback } from 'react';
import { markdownToPlainText } from '../../utils/clipboardText';

export const useMessageHandlers = () => {
  const [hoveredMessageId, setHoveredMessageId] = useState(null);
  const [copyStatus, setCopyStatus] = useState({});
  const [showReasoningMap, setShowReasoningMap] = useState({});

  const handleCopyMessage = useCallback(async (text) => {
    try {
      await navigator.clipboard.writeText(markdownToPlainText(text));
      setCopyStatus((prev) => ({ ...prev, [text]: true }));
      setTimeout(() => {
        setCopyStatus((prev) => ({ ...prev, [text]: false }));
      }, 2000);
    } catch (err) {
      console.error('Failed to copy text:', err);
    }
  }, []);

  const toggleReasoning = useCallback((messageId) => {
    setShowReasoningMap((prev) => ({
      ...prev,
      [messageId]: !prev[messageId],
    }));
  }, []);

  return {
    hoveredMessageId,
    setHoveredMessageId,
    copyStatus,
    showReasoningMap,
    setShowReasoningMap,
    handleCopyMessage,
    toggleReasoning
  };
};
